var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-polygon',{attrs:{"lat-lngs":_vm.boundary,"color":_vm.boundary.color},on:{"click":_vm.onClick}},[_c('l-popup',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.popup)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }